import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'material-ui/Tabs';
import { Provider } from 'react-redux';
import { store } from '../../';

import Tabs from './components/tabs';
import Modal from './components/modal';
import AccountHeader from './components/accountHeader';

import Subscriptions from './modules/subscriptions';
import Billing from './modules/billing';
import AppSumoBilling from './modules/appSumoBilling';
import Account from './modules/account';
import Profile from './modules/profile';
import Referral from './modules/referral';
import StaffProfile from './modules/staffProfile';
import ResetPassword from './modules/resetPassword';
import Preferences from './modules/preferences';
import { STAFF_ADMIN } from '../../config';

import './styles.scss';

const styles = {
  tab: {
    fontSize: '11px',
    height: 40,
    width: 120,
  },
};

const defineOptionalTabs = (
  integration,
  role,
  isAppAdmin,
  isAppSumoUser,
  isSubAdminWithMulipleApps,
) => {
  if (integration && integration.type) {
    return integration.type === 'Wix' ? <WixTabs /> : <WeeblyTabs />;
  }

  if (isAppAdmin || isSubAdminWithMulipleApps) {
    return <AppAdminPlatformTabs />;
  }

  return role !== STAFF_ADMIN ? (
    <CorePlatformTabs isAppSumoUser={isAppSumoUser} />
  ) : (
    <StaffPlatformTabs />
  );
};

const AccountModal = ({
  user,
  profile,
  staffProfile,
  open,
  handleClose,
  integration,
  role,
  isAppAdmin,
  isAppSumoUser,
  isSubAdminWithMulipleApps,
}) => (
  <Modal
    open={open}
    onRequestClose={handleClose}
    header={
      <AccountHeader
        email={user.email}
        name={
          role === STAFF_ADMIN
            ? `${staffProfile.firstName.value} ${staffProfile.lastName.value}`
            : profile.name.value
        }
      />
    }
  >
    {defineOptionalTabs(
      integration,
      role,
      isAppAdmin,
      isAppSumoUser,
      isSubAdminWithMulipleApps,
    )}
  </Modal>
);

const WeeblyTabs = () => (
  <Tabs>
    <Tab style={styles.tab} label="Plans">
      <Subscriptions />
    </Tab>
    <Tab style={styles.tab} label="Billing">
      <Billing />
    </Tab>
  </Tabs>
);

const WixTabs = () => (
  <Provider store={store}>
    <Tabs>
      <Tab style={styles.tab} label="Plans">
        <Subscriptions />
      </Tab>
    </Tabs>
  </Provider>
);
const CorePlatformTabs = ({ isAppSumoUser }) => (
  <Provider store={store}>
    <div className="account-tabs">
      <Tabs>
        <Tab style={styles.tab} label="Profile">
          <Profile />
        </Tab>
        <Tab style={styles.tab} label="Password">
          <ResetPassword />
        </Tab>
        <Tab style={styles.tab} label="Plans">
          <Subscriptions />
        </Tab>
        <Tab style={styles.tab} label="Billing">
          {isAppSumoUser ? <AppSumoBilling /> : <Billing />}
        </Tab>
        <Tab style={styles.tab} label="Account">
          <Account />
        </Tab>
        <Tab style={styles.tab} label="Referral">
          <Referral />
        </Tab>
        <Tab style={styles.tab} label="Preferences">
          <Preferences />
        </Tab>
      </Tabs>
    </div>
  </Provider>
);

const AppAdminPlatformTabs = () => (
  <Provider store={store}>
    <div className="account-tabs">
      <Tabs>
        <Tab style={styles.tab} label="Profile">
          <Profile />
        </Tab>
        <Tab style={styles.tab} label="Password">
          <ResetPassword />
        </Tab>
      </Tabs>
    </div>
  </Provider>
);

const StaffPlatformTabs = () => (
  <Provider store={store}>
    <div className="account-tabs">
      <Tabs>
        <Tab style={styles.tab} label="Profile">
          <StaffProfile />
        </Tab>
        <Tab style={styles.tab} label="Password">
          <ResetPassword />
        </Tab>
        <Tab style={styles.tab} label="Account">
          <Account />
        </Tab>
      </Tabs>
    </div>
  </Provider>
);

AccountModal.propTypes = {
  user: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  staffProfile: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  integration: PropTypes.object,
  role: PropTypes.string.isRequired,
  isAppAdmin: PropTypes.bool,
  isAppSumoUser: PropTypes.bool,
  isSubAdminWithMulipleApps: PropTypes.bool.isRequired,
};

AccountModal.defaultProps = {
  integration: null,
  role: '',
  isAppAdmin: false,
  isAppSumoUser: false,
};

export default AccountModal;
